import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import { ExpertProfileForm } from "@src/api/types";
import { LightLine, Line } from "@src/component/base/BasicFormWrapper";
import { EmptySpace } from "@src/component/SignComponent";
import React, { useEffect, useRef, useState } from "react";
import { ProfileEducationItem } from "../components/ProfileEducationItem";
import ProfileListItem from "../components/ProfileListItem";
import { ProfileProjectItem } from "../components/ProfileProjectItem";
import { ProfileRecordItem } from "../components/ProfileRecordItem";
interface ComponentProps {
	data: ExpertProfileForm;
	matchUuid: string;
	matchedSkills: string[];
	matchedExpertDataUuid: string;
	isNoShowButton?: boolean;
	noShowPortfolio?: boolean;
}

export const Section2 = ({
	data,
	matchUuid,
	matchedSkills,
	matchedExpertDataUuid,
	isNoShowButton,
	noShowPortfolio,
}: ComponentProps) => {
	const records = data.records;
	const projects = data.projects;
	const educations = data.educations;
	let isV2 = !!(records && records.length > 0);
	if (records?.length == 1 && records[0].companyName == "") isV2 = false;
	const getMatchSkills = (str: string, arr: string[]) => {
		const matchSkillsArr = str
			.split(",")
			.map((s) => s.trim())
			.filter((s) => s.length > 0);

		return matchSkillsArr
			.map((skill) => ({
				skill,
				isBold: arr.includes(skill),
			}))
			.sort((a, b) => {
				if (a.isBold && !b.isBold) return -1;
				else if (!a.isBold && b.isBold) return 1;
				else return 0;
			});
	};

	const containerRef = useRef<HTMLDivElement>(null);
	const [showMore, setShowMore] = useState(false);
	const [isOverflowing, setIsOverflowing] = useState(false);

	const containerRef2 = useRef<HTMLDivElement>(null);
	const [showMore2, setShowMore2] = useState(false);
	const [isOverflowing2, setIsOverflowing2] = useState(false);

	const [windowWidth, setWindowWidth] = useState(0);

	const handleResize = () => {
		setWindowWidth(window.innerWidth);
	};

	useEffect(() => {
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		const containerHeight = containerRef?.current?.clientHeight || 0;
		const scrollHeight = containerRef?.current?.scrollHeight || 0;
		if (scrollHeight > containerHeight) {
			setIsOverflowing(true);
		} else {
			setIsOverflowing(false);
		}
	}, [showMore, windowWidth]);

	useEffect(() => {
		const containerHeight = containerRef2?.current?.clientHeight || 0;
		const scrollHeight = containerRef2?.current?.scrollHeight || 0;
		if (scrollHeight > containerHeight) {
			setIsOverflowing2(true);
		} else {
			setIsOverflowing2(false);
		}
	}, [showMore2, windowWidth]);

	return (
		<Wrapper>
			<Grid container>
				{data.specialization && (
					<>
						<Line />
						<EmptySpace space={30} />
						<Grid item xs={12} sm={12} md={12}>
							<div className="detail-content-wrapper">
								<div className="skill-box">
									<div className="skill-title">전문 분야</div>
									<div
										className="skill-item-box"
										style={{
											maxHeight: showMore2 ? "none" : "150px",
											overflow: "hidden",
										}}
										ref={containerRef2}
									>
										{data.specialization.split(",").map((skillData, i) => (
											<React.Fragment key={`specialitem${i}`}>
												<div className="skill-item">{skillData}</div>
											</React.Fragment>
										))}
									</div>
								</div>
								{isOverflowing2 && (
									<button
										onClick={() => setShowMore2(!showMore2)}
										className="show-more-button"
									>
										{showMore ? "접기" : "더보기"}
									</button>
								)}
							</div>
						</Grid>
					</>
				)}
				{data.skill && (
					<Grid item xs={12} sm={12} md={12}>
						<div className="detail-content-wrapper">
							<div className="skill-box">
								<div className="skill-title">보유 스킬</div>
								<div
									className="skill-item-box"
									style={{
										maxHeight: showMore ? "none" : "150px",
										overflow: "hidden",
									}}
									ref={containerRef}
								>
									{getMatchSkills(data.skill, matchedSkills).map(
										(skillData, i) => (
											<React.Fragment key={`skillitem${i}`}>
												<div
													style={{
														backgroundColor: skillData.isBold
															? "var(--primary)"
															: "var(--bg-white)",
														color: skillData.isBold
															? "var(--bg-white)"
															: "var(--desc-gray)",
													}}
													className="skill-item"
												>
													{skillData.skill}
												</div>
											</React.Fragment>
										),
									)}
								</div>
							</div>
							{isOverflowing && (
								<button
									onClick={() => setShowMore(!showMore)}
									className="show-more-button"
								>
									{showMore ? "접기" : "더보기"}
								</button>
							)}
						</div>
					</Grid>
				)}
			</Grid>
			{isV2 && (
				<>
					{records && records.length > 0 && records[0].companyName != "" && (
						<div className="record-content-wrapper">
							<Line />
							<EmptySpace space={30} />

							<div className="record-content-box">
								<div className="record-title">주요 이력</div>
								<div className="record-content">
									{records.map(
										(record, i) =>
											record.companyName != "" && (
												<React.Fragment key={i}>
													<ProfileRecordItem {...record} />
													<EmptySpace space={30} />
													{i === records.length - 1 ? null : (
														<>
															<LightLine />
															<EmptySpace space={30} />
														</>
													)}
												</React.Fragment>
											),
									)}
								</div>
							</div>
						</div>
					)}
					{projects && projects.length > 0 && projects[0].title != "" && (
						<div className="project-content-wrapper">
							<Line />
							<EmptySpace space={30} />

							<div className="project-content-box">
								<div className="project-title">프로젝트</div>
								<div className="project-content">
									{projects.map(
										(project, i) =>
											project.title != "" && (
												<React.Fragment key={i}>
													<ProfileProjectItem {...project} />
													<EmptySpace space={30} />
													{i === projects.length - 1 ? null : (
														<>
															<LightLine />
															<EmptySpace space={30} />
														</>
													)}
												</React.Fragment>
											),
									)}
								</div>
							</div>
						</div>
					)}
				</>
			)}
			{!isV2 && (
				<>
					<Line />
					<EmptySpace space={30} />

					{data.resume && (
						<>
							<div className="subheading">주요 이력</div>
							<LightLine />
							<EmptySpace space={10} />
							<div className="desc">{data.resume}</div>
						</>
					)}

					{data.project && (
						<>
							<div className="subheading">프로젝트</div>
							<LightLine />
							<EmptySpace space={10} />
							<div className="desc">{data.project}</div>
						</>
					)}
				</>
			)}
			{educations && educations.length > 0 && educations[0].school != "" && (
				<div className="project-content-wrapper">
					<Line />
					<EmptySpace space={30} />

					<div className="project-content-box">
						<div className="project-title">학력</div>
						<div className="project-content">
							{educations.map(
								(education, i) =>
									education.school != "" && (
										<React.Fragment key={i + "education-profile-item"}>
											<ProfileEducationItem {...education} />
											<EmptySpace space={20} />
											{i === educations.length - 1 ? null : (
												<>
													<LightLine />
													<EmptySpace space={20} />
												</>
											)}
										</React.Fragment>
									),
							)}
						</div>
					</div>
				</div>
			)}
			<EmptySpace space={20} />
			{data.portfolioMasking && !noShowPortfolio ? (
				<>
					<div className="portfolio-content-wrapper">
						<Line />
						<EmptySpace space={30} />
						<div className="portfolio-content-box">
							<div className="title">외부 링크</div>
							<div className="portfolio-link-box">
								<img src="/static/image/link.png" />
								<a
									className="portfolio-link"
									target="_blank"
									href={data.portfolioMasking}
									rel="noreferrer"
								>
									포트폴리오
								</a>
							</div>
						</div>
					</div>
					<EmptySpace space={30} />
				</>
			) : null}
			<div className="detail-content-wrapper">
				<Line />
				<EmptySpace space={30} />
				<div id="detail-title">세부 경험</div>
				<EmptySpace space={20} />
				<ul style={{ margin: 0, padding: 0, position: "relative" }}>
					<ProfileListItem
						invisibleOption={true}
						text={data.businessType}
						title={"기업 유형"}
						dark={true}
					/>
					<ProfileListItem
						invisibleOption={true}
						text={data.business}
						title={"비즈니스 유형"}
						dark={true}
					/>
					<ProfileListItem
						invisibleOption={true}
						text={data.industry}
						title={"산업군"}
						dark={true}
					/>
					<ProfileListItem
						invisibleOption={true}
						text={data.country}
						title={"업무 가능 시장"}
						dark={true}
					/>
					<ProfileListItem
						invisibleOption={true}
						text={data.language}
						title={"업무 가능 언어"}
						dark={true}
					/>
				</ul>
			</div>
			{matchedExpertDataUuid && !isNoShowButton && (
				<>
					<Line />
					<EmptySpace space={30} />
					<div className="testsession-content-wrapper">
						<div className="testsession-content-box">
							<EmptySpace space={20} />
							<div className="">{`추천받은 모든 전문가 프로필에 대해 인터뷰 수락 또는 거절 의사를 밝혀주세요.`}</div>
							<EmptySpace space={2} />
							<div className="">
								{`원활한 인터뷰 진행을 위해 `}
								<a
									className="guide-link"
									target="_blank"
									href="https://notion.1point.kr/service/guide/test"
									rel="noreferrer"
								>
									{"가이드라인"}
								</a>
								{`을 확인해주세요.`}
							</div>
						</div>
					</div>
				</>
			)}
		</Wrapper>
	);
};

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;

	.title {
		color: var(--card-bg);
		font-size: 27px;
		font-weight: 800;
		line-height: normal;
		white-space: nowrap;
		width: 180px;

		@media screen and (max-width: 900px) {
			width: auto;
			margin-right: 20px;
		}
	}

	.record-content-wrapper {
		display: flex;
		flex-direction: column;

		.record-content-box {
			display: flex;
			flex-direction: row;

			@media screen and (max-width: 900px) {
				flex-direction: column;
			}

			.record-title {
				color: var(--card-bg);
				font-size: 27px;
				font-weight: 800;
				line-height: normal;
				white-space: nowrap;
				width: 100px;
			}

			.record-content {
				display: flex;
				flex-direction: column;
				flex-grow: 1;
				margin-left: 70px;

				@media screen and (max-width: 900px) {
					margin-top: 20px;
					margin-left: 0px;
				}
			}
		}
	}

	.subheading {
		font-size: 24px;
		font-weight: bold;
		white-space: pre-wrap;
		padding-bottom: 10px;
		position: relative;
	}

	.desc {
		font-size: 16px;
		white-space: pre-wrap;
		padding-bottom: 40px;

		> a {
			text-decoration: underline;
		}
	}

	.project-content-wrapper {
		display: flex;
		flex-direction: column;

		.project-content-box {
			display: flex;
			flex-direction: row;

			@media screen and (max-width: 900px) {
				flex-direction: column;
			}

			.project-title {
				color: var(--card-bg);
				font-size: 27px;
				font-weight: 800;
				line-height: normal;
				white-space: nowrap;
				width: 100px;
			}

			.project-content {
				display: flex;
				flex-direction: column;
				margin-left: 70px;
				flex-grow: 1;

				@media screen and (max-width: 900px) {
					margin-left: 0;
					margin-top: 20px;
				}
			}
		}
	}

	.detail-content-wrapper {
		display: flex;
		flex-direction: column;
		margin-bottom: 30px;

		#detail-title {
			color: var(--card-bg);
			font-size: 27px;
			font-weight: 800;
			line-height: normal;
			white-space: nowrap;
		}
	}

	.skill-special-box {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: center;
		flex-wrap: wrap;
	}

	.skill-box {
		display: flex;
		flex-direction: row;

		.skill-title {
			width: 150px;
			margin-right: 0px;
			color: var(--card-bg);
			font-size: 27px;
			font-weight: 800;
			line-height: normal;
			white-space: nowrap;
			flex: 0;
		}

		.skill-item-box {
			display: flex;
			flex-direction: row;
			align-items: start;
			justify-content: left;
			flex-grow: 1;
			flex-wrap: wrap;
			gap: 20px;
			margin-left: 70px;

			.skill-item {
				color: var(--desc-gray);
				font-size: 14px;
				font-weight: bold;
				padding: 5px 10px;
				border-radius: 4px;
				background-color: var(--bg-white);
			}
		}

		@media screen and (max-width: 900px) {
			flex-direction: column;
			gap: 10px;

			.skill-item-box {
				margin-left: 0px;
			}
		}
	}

	.show-more-button {
		margin-top: 20px;
		padding: 10px 20px;
		font-size: 14px;
		font-weight: bold;
		border: none;
		border-radius: 20px;
		background-color: var(--bg-white);
		color: var(--desc-gray);
		cursor: pointer;
	}

	.portfolio-content-wrapper {
		display: flex;
		flex-direction: column;

		.portfolio-content-box {
			display: flex;
			flex-direction: row;

			.title {
				width: 170px;
				margin-right: 0px;
			}

			.portfolio-link-box {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: left;
				flex-grow: 1;

				img {
					width: 20px;
					height: 20px;
				}

				.portfolio-link {
					color: var(--primary);
					color: var(--primary);
					font-size: 18px;
					font-weight: 600;
					line-height: normal;
					text-decoration-line: underline;
					margin-left: 5px;
				}
			}
		}
	}

	.comment-content-wrapper {
		display: flex;
		flex-direction: column;

		.comment-box {
			background-color: #303030;
			padding: 10px;

			.comment-title {
				font-size: 25px;
				font-style: normal;
				font-weight: 800;
				line-height: normal;
				padding: 10px 20px;
				color: rgb(8, 126, 255);
			}

			.comment-item-box {
				display: flex;
				flex-direction: row;
				align-items: center;
				padding: 10px 20px;
			}

			.comment-item-box2 {
				display: flex;
				flex-direction: column;
				align-items: start;
				padding: 10px 20px;
			}

			.comment-item-title {
				font-size: 20px;
				font-style: normal;
				font-weight: bold;
				color: var(--card-bg);
				white-space: wrap;
				flex-grow: 2;
			}

			.comment-item {
				color: #fff;
				display: flex;
				flex-direction: row;
				align-items: start;
				justify-content: left;
				flex-grow: 1;
				flex-wrap: wrap;
				gap: 20px;
				margin-left: 30px;
				font-size: 16px;
				flex-grow: 3;

				.skill {
					color: #fff;
					font-size: 13px;
					font-weight: 500;
					padding: 5px 10px;
					border-radius: 20px;
					background-color: #404040;
				}
			}

			.comment-desc {
				color: #fff;
				display: flex;
				flex-direction: row;
				align-items: start;
				justify-content: left;
				flex-grow: 1;
				flex-wrap: wrap;
				gap: 20px;
				font-size: 16px;
				margin-top: 10px;

				.linkify {
					color: var(--primary);
					cursor: pointer;
				}

				a {
					text-decoration: underline;
				}
			}
		}

		.comment-content-box {
			display: flex;
			flex-direction: column;

			@media screen and (max-width: 900px) {
				flex-direction: column;
			}

			.comment {
				color: #fff;
				font-size: 16px;
				font-weight: 400;
				line-height: 28px;
				white-space: pre-wrap;

				@media screen and (max-width: 900px) {
					margin-top: 20px;
				}
			}
		}
	}

	.testsession-content-wrapper {
		display: flex;
		flex-direction: row;
		width: 100%;

		.testsession-content-box {
			display: flex;
			flex-direction: column;
			width: 100%;
			color: var(--desc-gray);
			font-size: 16px;
			font-weight: 400;
			line-height: 28px;
			white-space: pre-wrap;
			align-items: center;

			.top {
				display: flex;
				flex-direction: column;
				width: 100%;
				align-items: center;
				text-align: center;

				@media screen and (max-width: 900px) {
					flex-direction: column;
					width: 100%;
					text-align: left;
				}
			}

			.sub-title {
				@media screen and (max-width: 900px) {
					margin-top: 20px;
				}
			}

			.btn {
				border-radius: 30px;
				border: 2px solid var(--primary);
				font-size: 20px;
				font-weight: 700;
				max-width: 450px;
				width: 100%;
				padding: 10px;

				@media screen and (max-width: 768px) {
					font-size: 16px;
				}
			}

			.testsession-btn {
				background-color: var(--primary);
				border-radius: 30px;

				font-size: 20px;
				font-weight: 700;
				max-width: 450px;
				width: 100%;
				padding: 10px;
			}

			a {
				color: var(--primary);
				text-decoration: underline;
			}
		}
	}
`;
